



const initState = {
  errore: null,
  recovered: null,
  ricevutomessaggio: null,
  loggedin: false,
  registered: false,
  profile: {},
  users: [],
  convs: [],
  erroreimpostazioni: false,
  messages: [],
};

const homeReducer = (state = initState, action) => {



  switch (action.type) {


    case "SENT_SUPPORT":
      return {
        ...state,
        errore: null,
        recovered: null,
        ricevutomessaggio: true,
      };

    case "RECOVERED":
      return {
        ...state,
        errore: null,
        recovered: true,
      };


    case "ERROR_RECOVERY":
      return {
        ...state,
        errore: "Error",
      };

    case "ERROR_LOGGING_USERNAME":
      return {
        ...state,
        errore: "Error",
        registered: false,
      };

    case "REGISTERED_SUCCESS":
      return {
        ...state,
        errore: null,
        registered: true,
      };

    case "ERROR_LOGGING_IN":
      return {
        ...state,
        errore: "Error",
      };

    case "ERROR_PHONE_LOGIN":
      return {
        ...state,
        errore: action.message || "Error",
      };

    case "RESET_ERRORS":
      return {
        ...state,
        errore: null,
        recovered: null,
        ricevutomessaggio: null,
        loggedin_doi: null,
        registered: false,

      };

    case "ERROR_LOGGING":
      return {
        ...state,
        errore: "",
      };

    case "ERROR_UPDATING_PROF":
      return {
        ...state,
        erroreimpostazioni:
          "",
      };

    case "CHANGEDPIC":
      return {
        ...state,
        profile: { ...state.profile, pic: action.d },
      };

    case "USER_PROFILE_DATA":
      return {
        ...state,
        userdata: action.d,
      };

    case "USER_PROFILE_DATA_OTHERS":
      return {
        ...state,
        userdata2: action.d,
      };






    case "USERS":
      return {
        ...state,
        users: action.d,
      };

    case "MESSAGES":
      return {
        ...state,
        messages: action.d,
      };

    case "CONVS":
      return {
        ...state,
        convs: action.d,
      };

    case "NOTIFICHE":
      return {
        ...state,
        notifiche_list: action.notifiche,

      };
    case "UNREADS":
      return {
        ...state,
        unreads: action.msg,
        notifiche: action.notifiche,

      };

    case "UPDATEPROF":
      return {
        ...state,
        //profile: action.d,
        profile: { ...state.profile, ...action.d },
      };

    case "LOGGEDIN_CONFIRM":
      return {
        ...state,
        errore: null,
        loggedin: false,
        loggedin_doi: true,
      };


    case "LOGGEDIN":
      return {
        ...state,
        errore: null,
        loggedin: true,
        profile: action.d[0],
      };

    case "LOGGEDOUT":
      return {
        ...initState,
        errore: null,
        loggedin: false,
        profile: {},
        messages: null,
        convs: null,


      };

    default:
      return state;
  }
};

export default homeReducer;
